import React from 'react';
import './StatusBadge.css';

const CONFIG = {
  new:       { label: 'New',       className: 'new' },
  paid:      { label: 'Paid',      className: 'paid' },
  donated:   { label: 'Donated',   className: 'donated' },
  unpaid:    { label: 'Unpaid',    className: 'unpaid' },
  pending:   { label: 'Pending',   className: 'pending' },
  cancelled: { label: 'Cancelled', className: 'cancelled' },
  printed:   { label: 'Printed',   className: 'printed' },
};

function StatusBadge({ status, title, bonus }) {
  const key       = status?.toLowerCase();
  const config    = CONFIG[key] ?? CONFIG.pending;
  const bonusPct  = Number(bonus);
  const hasBonus  = Number.isFinite(bonusPct) && bonusPct > 0;
  const bonusText = `${parseFloat(bonusPct.toFixed(2))}%`;
  const fullTitle = hasBonus
    ? [title, `${bonusText} bonus applied`].filter(Boolean).join(' — ')
    : title;

  return (
    <span className="status-badge-wrapper" title={fullTitle}>
      <span className={`status-badge status-badge--${config.className}`}>
        {config.label}
      </span>
      {hasBonus && (
        <span className="status-badge-ribbon" aria-hidden="true">+{bonusText}</span>
      )}
    </span>
  );
}

export default StatusBadge;
